import React from 'react'
import { FileText } from 'lucide-react'
import GenericTable from '../../components/GenericTable'

const AdminClaimDecisions = () => {
  return (
    <GenericTable
      tableName="claim_decisions"
      title="Claim Decisions"
      icon={FileText}
      iconColor="pink"
      searchFields={['decision_number', 'decision_status', 'decision_type', 'decision_result', 'reviewer_name']}
      hiddenFields={['decision_id', 'created_at', 'updated_at']}
      primaryKey="decision_id"
      defaultFields={['decision_number', 'decision_status', 'decision_type', 'decision_result', 'approved_amount', 'decision_date', 'reviewer_name', 'reviewer_designation']}
      addFields={['claim_id', 'decision_status', 'decision_type', 'decision_result', 'approved_amount', 'decision_reason', 'reviewer_name', 'reviewer_designation']}
      editFields={[
        'decision_status', 'decision_type', 'decision_result', 'approved_amount', 'rejection_reason', 'decision_reason',
        'decision_notes', 'reviewer_name', 'reviewer_designation', 'review_date', 'decision_date'
        // Excluded: decision_id, decision_number, claim_id, created_at, updated_at
      ]}
    />
  )
}

export default AdminClaimDecisions
